module.exports = __webpack_public_path__ + "7dc6b647daab073a90fd5dc6634fb4d9.jpg";